// 3rd parties
import { CloseButton } from "react-bootstrap";

import LoaderSpinner from "@/components/ReactBootstrap/LoaderSpinner/LoaderSpinner";
import { useOutside } from "@/hooks/useOutside";
import { useRef } from "react";

const RightSideBar = ({ onClose, loading, title, children }) => {
  const sideBarRef = useRef(null);
  useOutside(sideBarRef, () => {
    onClose(false);
  });

  const onCloseClick = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div ref={sideBarRef}>
      <div className="right-sidebar side-info-panel sidebar-fixed mw-100 slideInRight animated snt-right-sidebar">
        <div className="d-flex justify-content-between">
          <h4>{title || ""}</h4>
          <CloseButton onClick={onCloseClick} />
        </div>
        <div className="sidebar-inner sidebar-scrollbar pr10">
          <LoaderSpinner loading={loading} />
          {children}
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
